import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { abbreviateNumber, formatNumber } from '../../lib/utils';

const LineChart = ({ data }) => {
  const a = data
    .map((d, i) => {
      return {
        x: new Date().getFullYear() + i,
        y: Math.round(d)
      };
    })
    .slice(0, 20);

  const xAxisLabels = data
    .map((d, i) => (i % 2 === 0 ? new Date().getFullYear() + i : undefined))
    .slice(0, 20);

  const formattedData = [
    {
      id: 'line',
      data: a
    }
  ];

  return (
    <ResponsiveLine
      data={formattedData}
      margin={{ top: 0, right: 0, bottom: 2 * 16, left: 4 * 16 }}
      // xScale={{ type: "point" }}
      defs={[
        {
          id: 'gradientC',
          type: 'linearGradient',
          colors: [
            { offset: 0, color: '#05d748' },
            { offset: 100, color: '#05d748', opacity: 0 }
          ]
        }
      ]}
      fill={[{ match: '*', id: 'gradientC' }]}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: true,

        reverse: false
      }}
      endableArea
      enableCrosshair
      areaOpacity={0.2}
      lineWidth={1}
      animate
      axisTop={null}
      axisRight={null}
      tooltip={({ point }) => {
        return (
          <div>
            {point.data.x}: ${formatNumber(point.data.y)}
          </div>
        );
      }}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 16,
        tickRotation: 0,
        legend: null,
        legendOffset: 36,
        tickValues: xAxisLabels,
        legendPosition: 'middle'
      }}
      axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 16,
        tickRotation: 0,
        legend: null,
        legendOffset: -40,
        legendPosition: 'middle',
        format: v =>
          Math.sign(v) === -1
            ? `-$${abbreviateNumber(Math.abs(v))}`
            : `$${abbreviateNumber(Math.abs(v))}`
      }}
      enableGridX={false}
      enableGridY={false}
      colors={['rgb(5, 215, 72)']}
      pointSize={0}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={2}
      pointLabel="y"
      pointLabelYOffset={-12}
      enableArea
      useMesh
      // legends={null}
    />
  );
};

export default function CashFlowChart({ data, style = {} }) {
  return (
    <div style={{ height: 300, ...style }}>
      <LineChart data={data} />
    </div>
  );
}
